'use client'

import {useBugsnagErrorBoundary} from '~/utils/Bugsnag/useBugsnagErrorBoundary'
import {ErrorBoundaryFallback} from './_components/ErrorBoundary'
import type Error from 'next/error'

export default function ErrorPage({error}: {error: Error}) {
  useBugsnagErrorBoundary({error})

  return <ErrorBoundaryFallback />
}
